import {
  UPDATE_PASSWORD_ERROR,
  UPDATE_PASSWORD_SUCCESS,
  UpdatePasswordErrorAction,
} from 'modules/state/models/session';
import { createReducer } from 'util/reducers';

export interface ErrorState {
  changePassword: string[];
}

const initialState: ErrorState = {
  changePassword: [],
};

export default createReducer(initialState, {
  [UPDATE_PASSWORD_ERROR](state, { payload }: UpdatePasswordErrorAction) {
    if (state.changePassword.includes(payload)) {
      return state;
    }

    return {
      changePassword: [...state.changePassword, payload],
    };
  },

  [UPDATE_PASSWORD_SUCCESS](state) {
    return {
      changePassword: [],
    };
  },
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/ui/errors.ts